import {PhoneNumber} from './PhoneNumber';

export type WindshieldContactPhoneAttribute = {
  code: 'contact_phone';
  readonly type?: 'phone';
  readonly title?: string;
  value: PhoneNumber | null;
  readonly defaultValue?: PhoneNumber | null;
  readonly displayValue?: PhoneNumber | null;
  readonly extra?: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  readonly required?: boolean;
  override: boolean;
  hasPublishControl?: boolean;
  publish: boolean;
};
